import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import QuoteView from '../../../quotes/view/quoteView';
import { appConfig } from '@ami/react/core';
import { LinkButton } from '@ami/react/core';
import { withRouter } from 'react-router-dom';

const DownloadDocumentButton = ({
  onClick,
  documentId,
  documentIdDownloading,
}) => {
  const isDownloading = documentId === documentIdDownloading;
  return (
    <Button
      title={isDownloading ? 'Downloading' : 'Download Document'}
      className="btn btn-outline-primary"
      onClick={onClick}
    >
      {isDownloading && <i className="fa fa-spin fa-spinner" />}
      {!isDownloading && <i className="fa fa-download" />}
    </Button>
  );
};

const Document = ({
  quote,
  document,
  onDownloadDocument,
  onDeleteDocument,
  documentIdDownloading,
  canDelete,
  onOpenView,
}) => {
  const lineItem =
    document.lineItemId >= 0
      ? quote.lineItems.find((x) => x.id === document.lineItemId)
      : null;
  const viewLinkAmiTask =
    appConfig.isManagementApp && document.type === 'AmiTask';

  return (
    <li className="list-group-item document-item" key={document.id}>
      <div className="flextable">
        <div className="flextable-item flextable-primary">
          {document.name} {lineItem ? `(${lineItem.description})` : null}{' '}
          {viewLinkAmiTask && (
            <LinkButton
              id={document.relatedId}
              label="View Task"
              onClick={onOpenView.bind()}
            />
          )}
        </div>
        <div className="flextable-item">
          <ButtonGroup>
            <DownloadDocumentButton
              onClick={onDownloadDocument}
              documentIdDownloading={documentIdDownloading}
              documentId={document.id}
            />
            {canDelete && (
              <Button color="outline-primary" onClick={onDeleteDocument}>
                <span className="fa fa-trash" />
              </Button>
            )}
          </ButtonGroup>
        </div>
      </div>
    </li>
  );
};

class QuoteDocumentsListComponent extends React.PureComponent {
  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    canAddOrDeleteCustomDocuments: PropTypes.bool.isRequired,
    canAddOrDeleteSharedDocuments: PropTypes.bool.isRequired,
    onAddDocumentButtonClicked: PropTypes.func.isRequired,
    onAddSharedDocumentButtonClicked: PropTypes.func.isRequired,
    markDocumentToRemove: PropTypes.func.isRequired,
    downloadDocument: PropTypes.func.isRequired,
    documentIdDownloading: PropTypes.string,
  };

  handleOnOpenView = (amiTaskId) => {
    if (!amiTaskId) {
      throw Error('Cannot edit Task. Invalid id specified.');
    }
    this.props.history.push(`/ami-tasks/view/${amiTaskId}`);
  };

  render() {
    const {
      quote,
      canAddOrDeleteCustomDocuments,
      canAddOrDeleteSharedDocuments,
      documentIdDownloading,
      downloadDocument,
      onAddDocumentButtonClicked,
      onAddSharedDocumentButtonClicked,
      markDocumentToRemove,
    } = this.props;

    return (
      <div className="card mb-3 box-shadow quote-products flex-fill">
        <div className="card-body">
          <h6 className="card-title text-center">Documents</h6>
          <ul className="list-group list-group-flush">
            {quote.documents.map((document) => {
              const canDelete =
                (canAddOrDeleteCustomDocuments &&
                  document.type === 'Custom' &&
                  (appConfig.isManagementApp || document.isFromDealer)) ||
                (canAddOrDeleteSharedDocuments && document.type === 'Shared');
              return (
                <Document
                  key={document.id}
                  quote={quote}
                  documentIdDownloading={documentIdDownloading}
                  document={document}
                  onDownloadDocument={() =>
                    downloadDocument(quote.id, document)
                  }
                  canDelete={canDelete}
                  onDeleteDocument={() => markDocumentToRemove(document.id)}
                  onOpenView={this.handleOnOpenView}
                />
              );
            })}
          </ul>
          {quote.documents.length === 0 && (
            <div className="row">
              <div className="col text-center">This quote has no documents</div>
            </div>
          )}
          {(canAddOrDeleteCustomDocuments || canAddOrDeleteSharedDocuments) &&
            !quote.orderId && (
              <div className="row mt-3">
                <div className="col text-center">
                  <ButtonGroup>
                    {canAddOrDeleteCustomDocuments && (
                      <Button
                        color="outline-primary"
                        onClick={onAddDocumentButtonClicked}
                      >
                        Add Custom Document
                      </Button>
                    )}
                    {canAddOrDeleteSharedDocuments && (
                      <Button
                        color="outline-primary"
                        onClick={onAddSharedDocumentButtonClicked}
                      >
                        Add Shared Document
                      </Button>
                    )}
                  </ButtonGroup>
                </div>
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withRouter(QuoteDocumentsListComponent);
